<template>
  <article class="skuList-layout">
    <div class="p-top">
      <img
        class="p-left"
        :src="workerInfo.headImage | avatarAdvi(160, 160)"
        alt=""
      />
      <div class="p-right">
        <div class="price">
          <span class="pretxt" v-if="isSupPrePay && !weakenPrePay"
            >预付定金
          </span>
          <span class="pay">{{ skuPrice }}</span>
          <span class="qi" v-if="!selectedSku">起</span>
          <div v-if="skuBlackGoldPrice" class="black-gold">
            <span
              >黑金会员:{{ skuBlackGoldPrice
              }}<template v-if="!selectedSku">起</template></span
            >
          </div>
        </div>
        <div
          class="sku-name"
          :class="{ 'pay-period': isSupPrePay && !weakenPrePay }"
        >
          {{ chosenTxt }}
        </div>
      </div>
      <img
        class="close-icon"
        @click="$emit('handleClose')"
        src="../../assets/images/home/icon-删除-弹窗@3x.png"
      />
    </div>
    <div class="sku-list">
      <div class="sku-title">产品规格</div>
      <ul>
        <li
          :class="{ selected: selectedSku == item }"
          v-for="(item, index) in skuList"
          :key="index"
          @click="handleSelect(item)"
        >
          <div>
            <span>{{ item.cityName }}</span
            >&nbsp;&nbsp;<span>{{ item.serviceDays }}天</span>
          </div>
        </li>
      </ul>
    </div>
    <div class="btn-ui">
      <button @click="handelConfirmYuesao">
        {{ isSupPrePay && !weakenPrePay ? '支付定金' : '确定' }}
      </button>
    </div>
    <div class="menu_wkBox_back_box"></div>
  </article>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { trackClick } from '@/router/rear/ys_detail_tracker.js'
import price from '@/plugins/price'
import { cloneDeep } from 'lodash'

export default {
  props: {
    workerInfo: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      selectedSku: null, //选择的规格
      //skuList:[{cityName:'南京',cityId:'210100',days:26,price:22000},{cityName:'南京',cityId:'210100',days:42,price:42000}]
      weakenPrePay: true // 20220611 弱化预付定金模式
    }
  },
  computed: {
    ...mapState(['userInfo']),
    skuList() {
      return this.userInfo && this.userInfo.signSku ? this.userInfo.signSku : []
    },
    sortSkuListPrice() {
      if (this.userInfo && this.userInfo.signSku) {
        // fix: 直接sort方法会改变原数组导致vue infinite update loop
        const arr = cloneDeep(this.userInfo.signSku).sort((a, b) => {
          if (a.price > b.price) {
            return 1
          } else {
            return -1
          }
        })
        return arr || []
      } else {
        return null
      }
    },
    sortSkuListBlackGoldPrice() {
      if (this.userInfo && this.userInfo.signSku) {
        const arr = cloneDeep(this.userInfo.signSku).sort((a, b) => {
          if (a.hjSkuPrice > b.hjSkuPrice) {
            return 1
          } else {
            return -1
          }
        })
        return arr || []
      } else {
        return null
      }
    },
    isSupPrePay() {
      //支持定金支付
      if (!this.selectedSku) {
        return false
      } else {
        return (
          this.selectedSku.supportPayment &&
          this.selectedSku.supportPayment == 1
        )
      }
    },
    skuPrice() {
      //价格显示
      if (!this.selectedSku) {
        const pay = this.sortSkuListPrice && this.sortSkuListPrice[0].price
        return `¥${pay / 100}`
      } else {
        if (this.isSupPrePay && !this.weakenPrePay) {
          return `¥${this.selectedSku.paymentDepositPrice / 100}`
        }
        return `¥${this.selectedSku.price / 100}`
      }
    },
    skuBlackGoldPrice() {
      //黑金价格显示
      if (!this.selectedSku) {
        const pay =
          this.sortSkuListBlackGoldPrice &&
          this.sortSkuListBlackGoldPrice[0].hjSkuPrice
        return pay && pay / 100
      } else {
        return this.selectedSku.hjSkuPrice && this.selectedSku.hjSkuPrice / 100
      }
    },
    chosenTxt() {
      //已选规格后的提示文案
      if (!this.selectedSku) {
        return '请选择规格'
      } else {
        if (this.isSupPrePay && !this.weakenPrePay) {
          return `剩余尾款：¥${this.selectedSku.paymentEndPrice / 100}`
        }
        return `已选：${this.selectedSku.skuName}`
      }
    }
  },
  filters: {
    price(value) {
      return price(+value, 2, 2)
    }
  },
  methods: {
    handleSelect(item) {
      this.selectedSku = item
    },
    handelConfirmYuesao() {
      if (!this.selectedSku) {
        this.$$toast('先选择一个规格!')
      } else {
        trackClick('TOGGLE_DISTI')
        const query = this.$route.query
        const {
          cityId,
          cityName,
          serviceDays,
          starLevel,
          workerCode,
          skuId,
          spuId
        } = this.selectedSku
        let { headImage, workerName } = this.workerInfo
        headImage = encodeURIComponent(headImage)
        this.$router.push({
          name: 'confirmYuesao',
          query: {
            ...query,
            cityId,
            cityName,
            serviceDays,
            starLevel,
            workerCode,
            skuId,
            spuId,
            headImage,
            workerName
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.skuList-layout {
  background-color: #fff;
  padding: 0 rem(24px);
  padding-top: rem(36px);
  .p-top {
    display: flex;
    align-items: center;
    .p-left {
      border-radius: rem(16px);
      width: rem(160px);
      height: rem(160px);
      margin-right: rem(20px);
      object-fit: cover;
    }
    .p-right {
      .price {
        display: flex;
        align-items: center;
        .pretxt {
          font-size: rem(34px);
          font-weight: 500;
          color: #ff397e;
        }
        .pay {
          margin-left: rem(12px);
          font-size: rem(36px);
          font-weight: 500;
          color: #ff397e;
        }
        .qi {
          font-size: rem(26px);
          font-weight: 500;
          color: #ff397e;
          margin-left: rem(4px);
        }
        .black-gold {
          display: flex;
          align-items: center;
          position: relative;
          margin-left: rem(12px);
          &::before {
            content: '';
            display: block;
            width: rem(30px);
            height: rem(32px);
            background: url('~@/assets/images/icon-black_gold.png') 0 0/100%
              100% no-repeat;
          }
          span {
            padding: 0 rem(8px) 0 rem(2px);
            height: rem(32px);
            line-height: rem(32px);
            font-size: rem(20px);
            color: #464040;
            background-color: #f4dbc3;
            border-top-right-radius: 16px;
            border-bottom-right-radius: 16px;
          }
        }
      }
      .sku-name {
        margin-top: rem(16px);
        font-size: rem(26px);
        color: #666666;
        width: fit-content;
      }
      .pay-period {
        display: flex;
        align-items: center;
        padding: 0 rem(10px);
        height: rem(40px);
        line-height: rem(40px);
        color: #ff397e;
        background: #fff0f5;
        border-radius: 4px;
      }
    }
    .close-icon {
      position: absolute;
      right: rem(29px);
      top: rem(29px);
      width: rem(26px);
      height: rem(26px);
    }
  }
  .sku-list {
    padding-bottom: 0.24rem;
    margin-top: rem(60px);
    .sku-title {
      font-size: rem(32px);
      font-weight: 500;
      color: #121212;
      padding-bottom: rem(16px);
    }
    ul {
      display: flex;
      margin: 0 rem(-9px);
      padding-bottom: rem(130px);
      flex-wrap: wrap;
      li {
        padding: rem(16px) rem(9px);
        > div {
          width: rem(204px);
          text-align: center;
          height: rem(60px);
          line-height: rem(60px);
          font-size: rem(26px);
          font-weight: normal;
          color: #000;
          background: #f2f2f2;
          border-radius: rem(30px);
        }
        &.selected {
          > div {
            color: #ff397e;
            font-weight: 500;
            background-color: #ffecf1;
            @include border(all, #ff397e, 1px, 0.72rem);
          }
        }
      }
    }
  }
  .btn-ui {
    width: 100%;
    padding: rem(20px) 0;
    button {
      border-radius: rem(80px);
      width: 100%;
      line-height: rem(80px);
      height: rem(80px);
      display: block;
      font-size: rem(32px);
      color: #ffffff;
      border: 0;
      background-image: linear-gradient(90deg, #ff397e 0%, #ff074c 100%);
    }
  }
}
</style>
